export default {
  'domains-list': 'Domainübersicht',
  'domains-list-deleted': 'Gelöschte Domains',
  'domains-single': 'Domain ansehen',
  'domains-create': 'Domains bestellen',
  'domain-handles-list': 'Kontaktübersicht',
  'domain-nameservers-list': 'Nameserverübersicht',

  'dns-zones-list': 'Zonenübersicht',

  'general-dashboard': 'Dashboard',


  'domain': 'Domains',
  'dns': 'DNS',
  'domain-setup': 'Voreinstellungen',
  'domain-prices':'Domainpreise Ansehen',
  'handle-single-view':'Handle',

  'vservers-create':'Vserver Erstellen',
  'vservers-list':'Vserver',
  'vservers-single':'Vserver',

  'servers' : 'Server',

  'accounting':'Buchhaltung',
  'accounting-balance':'Konto',
  'accounting-open':'Offene Positionen',
  'accounting-debit':'Lastschrift',
  'accounting-bill':'Rechnungen',
  'accounting-transaction':'Transaktionen'
}



// WEBPACK FOOTER //
// ./src/lang/de/page_titles.js